export default __webpack_public_path__ + "static/singlestone-6d3219512ed59d16fa02b60ec11191ab.png";